import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialLock1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 25.9H32v4.58h-1.52Zm0-24.38H32v4.57h-1.52ZM25.91 0h4.57v1.52h-4.57Zm0 30.48h4.57V32h-4.57Zm-1.53-16.77h1.53v13.72h-1.53Zm-1.52 13.72h1.52v1.52h-1.52ZM9.15 28.95h13.71v1.53H9.15Zm10.66-25.9h1.53v1.52h-1.53Zm-6.09 19.81h1.52v3.04h1.52v-3.04h1.53v-1.53h1.52v-3.05h-1.52v1.53h-1.53v-1.53h1.53v-1.52h-4.57v1.52h-1.53v3.05h1.53zM12.19 1.52h7.62v1.53h-7.62Zm-1.52 1.53h1.52v1.52h-1.52Zm0 9.14V4.57H9.15v7.62H7.62v1.52h16.76v-1.52h-1.52V4.57h-1.52v7.62zM7.62 27.43h1.53v1.52H7.62ZM6.1 13.71h1.52v13.72H6.1ZM1.53 30.48H6.1V32H1.53ZM1.53 0H6.1v1.52H1.53ZM0 25.9h1.53v4.58H0ZM0 1.52h1.53v4.57H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialLock1
